<div class="close">
  <button mat-dialog-close>
    <img
      alt="close"
      width="24"
      height="24"
      src="../../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">选择不可用订阅的补偿计划</div>
<div class="content">
  <div class="detail1-3">
    <div class="imgs">
      <img src="../../../../assets/images/compensate/netflix.webp" alt="" />
      <img src="../../../../assets/images/compensate/change.webp" alt="" />
      <img src="../../../../assets/images/compensate/popcorn.webp" alt="" />
    </div>
    <div class="item">
      <span class="left">过期时间：</span>
      <span class="right"
        ><app-datetime [text]="data.ended_time"></app-datetime
      ></span>
    </div>
    <div class="item">
      <span class="left">剩余时间：</span
      ><span class="right">{{ data.remaining_days }}天</span>
    </div>
    <div class="item" style="color: #9f0000">
      <span class="left">转换时间：</span
      ><span class="right">{{ data.remaining_days * 2 }}天</span>
    </div>
    <div class="tip">温馨提示 ：</div>
    <div class="tip">
      Popcorn仅支持win和mac电脑pc端,其它设备都无法使用兑换码仅可在Popcorn客户端中使用，请您先下载并安装客户端，再通过输入兑换码完成爆米花会员的激活。
    </div>
  </div>
</div>
<div class="button">
  <button
    matRipple
    style="background: #00ad9d"
    [disabled]="loading"
    (click)="changePopcorn()"
  >
    立即确认并转换
  </button>
</div>
